import React from "react";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { observer, PropTypes as mbxPropTypes } from "mobx-react";

// Local Modules
import AgentRow from "./AgentRow";

const AgentList = observer(({ agentList, isMobile }) => {
  return (
    <Grid item md={6} sm={12} xs={12}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography
                variant={!isMobile ? "headline" : "display2"}
                align="left"
              >
                Agent
              </Typography>
            </TableCell>
            <TableCell>
              <Typography
                variant={!isMobile ? "headline" : "display2"}
                align="left"
              >
                Last billed for Week
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>

        <AgentRow agentList={agentList} isMobile={isMobile} />
      </Table>
    </Grid>
  );
});

AgentList.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  agentList: mbxPropTypes.observableArrayOf(PropTypes.object),
};

export default AgentList;
